/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as TermosRouteImport } from './routes/termos'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacidadeRoute = PrivacidadeRouteImport.update({
  id: '/privacidade',
  path: '/privacidade',
  getParentRoute: () => rootRouteImport,
} as any)
const TermosRoute = TermosRouteImport.update({
  id: '/termos',
  path: '/termos',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/privacidade': typeof PrivacidadeRoute
  '/termos': typeof TermosRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/privacidade': typeof PrivacidadeRoute
  '/termos': typeof TermosRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/privacidade': typeof PrivacidadeRoute
  '/termos': typeof TermosRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/privacidade' | '/termos'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/privacidade' | '/termos'
  id: '__root__' | '/' | '/privacidade' | '/termos'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PrivacidadeRoute: typeof PrivacidadeRoute
  TermosRoute: typeof TermosRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacidade': {
      id: '/privacidade'
      path: '/privacidade'
      fullPath: '/privacidade'
      preLoaderRoute: typeof PrivacidadeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/termos': {
      id: '/termos'
      path: '/termos'
      fullPath: '/termos'
      preLoaderRoute: typeof TermosRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PrivacidadeRoute: PrivacidadeRoute,
  TermosRoute: TermosRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
